// extracted by mini-css-extract-plugin
export default {"active":"onoff_active__iGBPT","activeSwitch":"onoff_activeSwitch__tMDEz","inactive":"onoff_inactive__BnwqH","extra":"onoff_extra__oh5Zn","onOffBtn":"onoff_onOffBtn__uu4us"};